module.exports = __webpack_public_path__ + "static/media/Roserade_gaussian2.0549cf7a.png";